/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import { GovernmentEndorsements } from '../../model/GovernmentEndorsements';
import { GovermentEndorsementsService } from '../../services/goverment-endorsements.service';
import { RegionService } from '../../services/region.service';
import { Region } from '../../model/Region';
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-endorsements',
    templateUrl: './endorsements-gov.component.html',
    styleUrls: ['./endorsements-gov.component.css'],
    standalone: false
})
export class GovernmentEndorsementsComponent extends BaseMessageComponent implements OnInit {
    public endorsements: GovernmentEndorsements[];
    public regions: Region[];
    indexWithChanges: number[] = [];

    constructor(
        private regionService: RegionService,
        private governmentEndorsementsService: GovermentEndorsementsService,
        private spinnerService: NgxSpinnerService,
        cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        this.getAllEndorsements();
        this.getRegions();
    }

    getRegions(): void {
        this.regionService.getAll().subscribe(
            regions => {
                this.regions = regions;
                this.cdr.detectChanges();
            }
        );
    }

    getAllEndorsements(): void {
        this.spinnerService.show();
        this.endorsements = [];
        this.indexWithChanges = [];
        this.governmentEndorsementsService.getAll().subscribe(value => {
            this.endorsements = value;
            this.cdr.detectChanges();
        },
            err => {
                console.log(err);
                alert(err);
                this.spinnerService.hide();
            },
            () => {
                this.spinnerService.hide();
            }
        );
    }

    addNew(name: string, regionId: number) {
      if (name.trim() == "") {
        alert("Please add a name before saving a new record.");
      } else {
        this.spinnerService.show();
        var newEndorsement = new GovernmentEndorsements();
        newEndorsement.endorsementName = name;
        newEndorsement.regionId = regionId;

        this.governmentEndorsementsService.addNew(newEndorsement).subscribe(value => {
            //success
            this.endorsements = null;
            this.getAllEndorsements();
          }, (error) => {
            //failed
            console.error(error);
            if (error.status=='409')
              alert("Duplicate Value(s) found.");
            else
              alert(error.message);
            this.spinnerService.hide();
          },
          () => {
            this.spinnerService.hide();
          });
      }
    }

    updateIndexes(index) {
        if (this.indexWithChanges.indexOf(index) === -1) {
            this.indexWithChanges.push(index);
        }
        console.log(this.indexWithChanges);
    }

    resetChanges() {
        this.getAllEndorsements();
    }

    saveChanges() {
      this.spinnerService.show();
        if (this.indexWithChanges.length > 0) {
            for (var i = 0; i < this.indexWithChanges.length; i++) {
                var idx = this.indexWithChanges[i];
                this.governmentEndorsementsService.updateEndorsement(this.endorsements[idx]).subscribe(value => {
                    console.log(this.endorsements[idx] + " saved.")
                }, (error) => {
                    //failed
                    console.error(error);
                    if (error.status=='409')
                      alert("Duplicate Value(s) found.");
                    else
                      alert(error.message);
                    this.spinnerService.hide();
                },
                    () => {
                        this.spinnerService.hide();
                        this.indexWithChanges = [];
                    });
            }
          setTimeout(() => {
            this.getAllEndorsements();
          }, 3000);
        } else {
          this.spinnerService.hide();
          alert("No changes to save.");
        }
    }
}
